import { MessageCircle, MapPin, Building2 } from "lucide-react";
import { SITE, waLink, WA_MESSAGES } from "@/config/site";

const EXPLORE = [
  { label: "Home", href: "/" },
  { label: "Find Nursing Homes", href: "/#matcher" },
  { label: "Nursing Home Costs", href: "/pricing-guide/" },
  { label: "How to Choose a Nursing Home", href: "/how-to-choose-a-nursing-home/" },
  { label: "Contact & Free Matching", href: "/contact/" },
];

const CARE = [
  { label: "Assisted Living", href: "/categories/assisted-living/" },
  { label: "Luxury Senior Living", href: "/categories/luxury-senior-living/" },
  { label: "Dementia & Rehabilitation Care", href: "/categories/dementia-and-rehab/" },
  { label: "Daily Senior Daycare", href: "/services/daily-daycare/" },
  { label: "Weekly & Short-Term Respite", href: "/services/weekly-short-stay/" },
  { label: "Monthly Long-Term Residential", href: "/services/monthly-long-term/" },
  { label: "Caregiver Packages", href: "/caregiver-packages/" },
];

const LinkCol = ({ title, links }) => (
  <div>
    <h3 className="font-display font-semibold text-white text-sm uppercase tracking-widest mb-4">{title}</h3>
    <ul className="space-y-2.5">
      {links.map((l) => (
        <li key={l.href + l.label}>
          <a href={l.href} className="text-sm text-white/70 hover:text-brand-gold transition-colors duration-200">
            {l.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

const Footer = () => (
  <footer data-testid="site-footer" className="bg-brand-teal text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <a href="/" aria-label="Nursing Home in Penang — home" className="inline-flex items-center gap-3">
            <img src="/assets/logo-horizontal.png" alt="Nursing Home in Penang logo mark" width="64" height="64" className="h-14 w-14 rounded-full bg-white object-contain p-1" />
            <span className="font-display font-bold text-lg leading-tight">
              Nursing<span className="text-brand-gold">Home</span>
              <span className="block text-xs font-medium tracking-[0.25em] text-white/70">IN PENANG</span>
            </span>
          </a>
          <p className="mt-5 text-sm text-white/70 leading-relaxed">
            An independent nursing home directory and free care-matching platform helping families find, compare and
            enquire about elderly care across Penang, Malaysia.
          </p>
          <a
            href={waLink(WA_MESSAGES.homepage)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="mt-5 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-medium text-white hover:bg-brand-gold transition-colors duration-300"
          >
            <MessageCircle className="h-4 w-4" /> WhatsApp {SITE.whatsappDisplay}
          </a>
        </div>
        <LinkCol title="Explore" links={EXPLORE} />
        <LinkCol title="Care & Services" links={CARE} />
        <div>
          <h3 className="font-display font-semibold text-white text-sm uppercase tracking-widest mb-4">Company</h3>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex gap-2">
              <Building2 className="h-4 w-4 mt-0.5 shrink-0 text-brand-gold" />
              <span>
                {SITE.company.name}
                <br />
                <span className="text-white/50">Reg. No. {SITE.company.registration}</span>
              </span>
            </li>
            <li className="flex gap-2">
              <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-brand-gold" />
              <span>{SITE.company.address}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-12 pt-8 border-t border-white/15 space-y-3">
        <p className="text-xs text-white/50">
          © {new Date().getFullYear()} {SITE.company.name}. All rights reserved. · {SITE.domain}
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
